import { computed } from 'vue';
import type { Ref } from 'vue';
import type { Image } from 'components/atoms/media/image/types';

export const useSrcset = (image: Ref<Image | null>) => {
  return computed(() => {
    const srcset: string[] = [];

    if (image.value?.sizes) {
      Object.values(image.value.sizes).forEach(value => {
        if (value.url) {
          srcset.push(`${value.url} ${value.width}w`);
        }
      });
    }

    return srcset.join(', ');
  });
};
